import React from "react";

const Inspiration = () => {
  return (
    <section id="inspiration">
      <h2>Get Inspiration with Tripoto's Exclusive Online Workshops</h2>
      <div className="inspirations-wrapper">
        <div className="inspiration1 inspirations">
          <img src="./Assets/inspirations/inpspirations1.png" />
          <h3>PACKAGE</h3>
          <br />
          <h4>How To Give Up City Life and Settle in The Mountains|Anu</h4>
          <br />
          <div className="inspirations-flex">
            <h4>Rs 1,000/person</h4>
            <button>Book Now</button>
          </div>
        </div>
        <div className="inspirations2 inspirations">
          <img src="./Assets/inspirations/inspirations2.png" />
          <h3>PACKAGE</h3>
          <br />
          <h4>
            Ways To Travel While Managing Your Own Expenses As A Student| Kalash
            Rajvansh
          </h4>
          <br />
          <div className="inspirations-flex">
            <h4>Rs 1,000/person</h4>
            <button>Book Now</button>
          </div>
        </div>
        <div className="inspirations3 inspirations">
          <img src="./Assets/inspirations/inspirations3.png" />
          <h3>PACKAGE</h3>
          <br />
          <h4>How To Travel In Exchange For Work|Raghu Raahi</h4>
          <br />
          <div className="inspirations-flex">
            <h4>Rs 1,000/person</h4>
            <button>Book Now</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Inspiration;
